export default __webpack_public_path__ + "static/media/flag-austria.7a2c0833.svg";